module.exports = __webpack_public_path__ + "images/emoji/mountain_railway.47685de17287099ccf99.png";